class LinyumMaterialProof extends HTMLElement {
 connectedCallback(){
  this.controller?.abort();this.controller=new AbortController();
  this.variants=JSON.parse(this.querySelector('[data-lny-material-variants]')?.textContent||'[]');
  const options={signal:this.controller.signal};
  document.addEventListener('change',e=>{if(e.target.closest('variant-picker')?.dataset.sectionId===this.dataset.sectionId)this.update();},options);
  document.addEventListener('shopify:product:select',e=>{if(e.target?.dataset?.sectionId===this.dataset.sectionId)Promise.resolve(e.promise).then(()=>this.update()).catch(()=>{});},options);
  this.update();
 }
 disconnectedCallback(){this.controller?.abort()}
 update(){
  const idx=Number(this.dataset.materialIndex);if(idx<0)return;
  const picker=document.querySelector(`variant-picker[data-product-id="${this.dataset.productId}"][data-section-id="${this.dataset.sectionId}"]`);
  const values=picker?[...picker.querySelectorAll('select')].map(x=>x.value):[];
  if(!values.length&&picker)for(const f of picker.querySelectorAll('fieldset'))values.push(f.querySelector('input:checked')?.value);
  const variant=this.variants.find(v=>v.options.every((o,i)=>o===values[i]));if(!variant)return;
  const label=variant.options[idx];const title=this.querySelector('.linyum-material-proof__title');const seal=this.querySelector('.linyum-material-proof__seal');
  if(title)title.textContent=label;
  if(seal)seal.textContent=label.includes('925')?'925':label.includes('14')?'14K':'L';
 }
}
if(!customElements.get('linyum-material-proof'))customElements.define('linyum-material-proof',LinyumMaterialProof);
